import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router";
import { CircularProgress } from "@mui/material";
import { useUserAuth } from "../context/UserAuthContext";
import { FUNCTIONS } from "../config";

const HubSpotAuth = () => {
    const { user, orgId } = useUserAuth();
    const navigate = useNavigate();
    const [status, setStatus] = useState("connecting");
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!user?.uid || !orgId) return;

        const oauthCode = new URLSearchParams(window.location.search).get('code');

        if (!oauthCode) {
            setStatus("error");
            setError("No authorization code found. Please try connecting again.");
            return;
        }

        const runOAuthFlow = async () => {
            try {
                setStatus("connecting");
                const redirectUri = `${window.location.origin}/auth-hubspot`;
                const token = await user.getIdToken();

                const res = await fetch(FUNCTIONS.hubspotOAuthConnect, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({ oauthCode, redirectUri }),
                });

                if (!res.ok) {
                    const errData = await res.json().catch(() => ({}));
                    throw new Error(errData.error || `Connection failed: ${res.status}`);
                }

                setStatus("success");
                navigate("/auth");
            } catch (error) {
                console.error("OAuth flow error:", error);
                setStatus("error");
                setError("Something went wrong connecting your account. Please try again.");
            }
        };

        runOAuthFlow();
    }, [navigate, user, orgId]);

    const statusMessages = {
        connecting: "Connecting your HubSpot account...",
        error: "Connection Failed",
    };

    return (
        <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "48px",
            textAlign: "center",
            color: "black",
        }}>
            {status !== "error" && <CircularProgress style={{ color: "#825ee7", marginBottom: "24px" }} />}
            <h3 style={{ marginBottom: "8px" }}>{statusMessages[status]}</h3>
            {status !== "error" && (
                <p style={{ color: "#666" }}>Please wait while we securely link your account.</p>
            )}
            {status === "error" && (
                <p style={{ color: "#d32f2f" }}>{error}</p>
            )}
        </div>
    );
};

export default HubSpotAuth;
